import { render } from "./TrashCourse.vue?vue&type=template&id=69f24056"
import script from "./TrashCourse.vue?vue&type=script&lang=js"
export * from "./TrashCourse.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/roshdfarms-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__